
import {Component, Input} from "@angular/core";
import {UI_TEXTS} from "../../enums/e-texts";
import {JP} from "../../helpers/jp";
import {FactoryService} from "../../services/factory.service";
import {ISlide} from "../../services/factory-service-impl/story.utils";
import {SLIDES_TRANSITIONS_TYPES_LIST} from "../../enums/e-scene-types";

@Component({
  selector:"nv-slides",
  templateUrl:"./nv-slides.component.html"
})
export class NvSlidesComponent{


  UI_TEXTS = UI_TEXTS;
  TRANSITIONS = SLIDES_TRANSITIONS_TYPES_LIST;

  private _document:any;
  private _pointer:string;
  private _selected:ISlide;

  @Input() set document(value: any) { this._document = value; }
  @Input() set pointer(value: string) { this._pointer = value; }

  get selected(): ISlide { return this._selected; }
  get document(): any { return this._document; }
  get pointer(): string { return this._pointer; }
  get slides():string[] {
    return JP.get(this.document, this._pointer);
  }

  constructor(private factoryService: FactoryService) { }

  getLabel(slide:ISlide){
    return slide.url;
  }

  onItemSelected(slide:ISlide){
    this._selected = slide;
    //console.log(this._selected);
  }

  onAddClick(){
    this.factoryService.addSlideTo(this.document,this.pointer);
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-scenes/nv-slides.component.ts